// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"34a8e9c3","513":"db1c3ba4","787":"0ce25c46"}[chunkId] + ".chunk.js";
};